<template>
  <div>
    <!-- style="position:absolute;bottom:-999px;width:1920px;" -->
    <div ref="pdfTemple" class="pdfTemple" style="position:absolute;bottom:-9999px;width:1920px;">
        <div class="title">WareHouse Recpit Check</div>
        <div class="flex-align flex-spacebetween" style="border-bottom: 2px solid #ccc;margin-bottom:10px;">
          <div>
            <div class="form-item flex-align">
              <div class="form-label">Document Date:</div>
              <div class="form-value">{{ data.auditTime }}</div>
            </div>
            <div class="form-item flex-align">
              <div class="form-label">Purchase Order No.:</div>
              <div class="form-value">{{ data.code }}</div>
            </div>
            <div class="form-item flex-align">
              <div class="form-label">Supllier ID:</div>
              <div class="form-value">{{ data.supplierCode }}</div>
            </div>
          </div>
          <img :src="$getPublicImage('sello.jpg')" style="width:160px;height:80px;" />
          <div>
            <div class="form-item flex-align">
              <div class="form-label">Sello Products Pty Ltd</div>
            </div>
            <div class="form-item flex-align">
              <div class="form-label">7 Duigan Drive</div>
            </div>
            <div class="form-item flex-align">
              <div class="form-label">MOORABBIN AIRPORT VIC</div>
            </div>
            <div class="form-item flex-align">
              <div class="form-label">3194</div>
            </div>
            <div class="form-item flex-align">
              <div class="form-label">AUSTRALIA</div>
            </div>
          </div>
        </div>
        <div class="flex-align flex-spacebetween" style="margin:20px 0">
          <div class="flex">
            <div class="form-item">
              <div class="form-label">Suplier Information:</div>
              <div class="form-value">{{ data.supplierName }}</div>
            </div>
            <div class="form-item">
              <div class="form-label">Ship To:</div>
              <div class="form-value">Sello Products Pty Ltd</div>
              <div class="form-value">7 Duigan Drive</div>
              <div class="form-value">MOORABBIN AIRPORT VIC</div>
              <div class="form-value">3194</div>
              <div class="form-value">AUSTRALIA
                <b style="margin-left:20px;">Note: Please fill ctn details if it is more than one pice</b>
              </div>
            </div>
          </div>
          <div>
            <div class="form-item flex-align">
              <div class="form-label" style="width: 100px;">Order Date:</div>
              <div class="form-value" style="width: 160px;">{{ data.creationDate }}</div>
            </div>
            <div class="form-item flex-align">
              <div class="form-label" style="width: 100px;">reference:</div>
              <div class="form-value" style="width: 160px;">{{ data.vendorRefNo }}</div>
            </div>
          </div>
        </div>
        <el-table class="emptyItem" :data="data.goodsList">
          <el-table-column label="Item" prop="skuCode" align="center" />
          <el-table-column label="Description" prop="skuName" align="center" />
          <el-table-column label="How many Ctn" prop="aaa" align="center" />
          <el-table-column label="Ctn Barcode" prop="rpcGoodsResVO.cartonBoxBarcode" align="center" />
          <el-table-column label="Ctn Qty" prop="rpcGoodsResVO.qty" align="center" />
          <el-table-column label="Ctn Length" prop="rpcGoodsResVO.cartonLength" align="center" />
          <el-table-column label="Ctn Width" prop="rpcGoodsResVO.cartonWidth" align="center" />
          <el-table-column label="Ctn Height" prop="rpcGoodsResVO.cartonHeight" align="center" />
          <el-table-column label="Ctn Weight" prop="rpcGoodsResVO.cartonWeight" align="center" />
          <el-table-column label="Unit Barcode" prop="rpcGoodsResVO.barCode" align="center" />
          <el-table-column label="Unit Qty" prop="alreadyQty" align="center" />
          <el-table-column label="Unit Length" prop="rpcGoodsResVO.length" align="center" />
          <el-table-column label="Unit Width" prop="rpcGoodsResVO.width" align="center" />
          <el-table-column label="Unit Height" prop="rpcGoodsResVO.height" align="center" />
          <el-table-column label="Unit Weight" prop="rpcGoodsResVO.weight" align="center" />
          <el-table-column label="Remarks" align="center">
            <template slot-scope="scope">{{ scope.row.purchaseType == 'COMMON' ? '': data.remark }}</template>
          </el-table-column>
        </el-table>
        <div class="flex-column">
          <div style="margin:20px 0;">
            <b>Name______________________________</b>
            <b style="margin-left:5px;">Date______________________________</b>
          </div>
          <b>Signature______________________________</b>
        </div>
    </div>

    <div ref="pdfTemple1" class="pdfTemple" style="position:absolute;top:-9999px;width:1920px;">
      <div class="title">PURCHASE QUOTATAION</div>
      <div class="flex-align flex-spacebetween" style="border-bottom: 2px solid #ccc;margin-bottom:10px;">
        <div>
          <div class="form-item flex-align">
            <div class="form-label">Document Date:</div>
            <div class="form-value">{{ data.auditTime }}</div>
          </div>
          <div class="form-item flex-align">
            <div class="form-label">Purchase Order No.:</div>
            <div class="form-value">{{ data.code }}</div>
          </div>
          <div class="form-item flex-align">
            <div class="form-label">Supllier ID:</div>
            <div class="form-value">{{ data.supplierCode }}</div>
          </div>
          <div class="form-item flex-align">
            <div class="form-label">Purchase Amt:</div>
            <div class="form-value">{{ purchaseAmt }}</div>
          </div>
        </div>
        <img :src="$getPublicImage('sello.jpg')" style="width:160px;height:80px;" />
        <div>
          <div class="form-item flex-align">
            <div class="form-label">Sello Products Pty Ltd</div>
          </div>
          <div class="form-item flex-align">
            <div class="form-label">7 Duigan Drive</div>
          </div>
          <div class="form-item flex-align">
            <div class="form-label">MOORABBIN AIRPORT VIC</div>
          </div>
          <div class="form-item flex-align">
            <div class="form-label">3194</div>
          </div>
          <div class="form-item flex-align">
            <div class="form-label">AUSTRALIA</div>
          </div>
        </div>
      </div>
      <div class="flex-align flex-spacebetween" style="margin:20px 0">
        <div class="flex">
          <div class="form-item">
            <div class="form-label">Suplier Information:</div>
            <div class="form-value">{{ data.supplierName }}</div>
          </div>
          <div class="form-item">
            <div class="form-label">Ship To:</div>
            <div class="form-value">Sello Products Pty Ltd</div>
            <div class="form-value">7 Duigan Drive</div>
            <div class="form-value">MOORABBIN AIRPORT VIC</div>
            <div class="form-value">3194</div>
            <div class="form-value">AUSTRALIA</div>
          </div>
        </div>
        <div>
          <div class="form-item flex-align">
            <div class="form-label" style="width: 100px;">Order Date:</div>
            <div class="form-value" style="width: 160px;">{{ data.creationDate }}</div>
          </div>
          <div class="form-item flex-align">
            <div class="form-label" style="width: 100px;">Delivery By:</div>
            <div class="form-value" style="width: 160px;">{{ data.finishTime }}</div>
          </div>
          <div class="form-item flex-align">
            <div class="form-label" style="width: 100px;">Cancel Date:</div>
            <div class="form-value" style="width: 160px;">{{ data.expectedDate }}</div>
          </div>
        </div>
      </div>
      <el-table class="emptyItem" :data="data.goodsList">
        <el-table-column label="Item" prop="rpcGoodsResVO.skuCode" align="center" />
        <el-table-column label="Description" prop="rpcGoodsResVO.skuName" align="center" />
        <el-table-column label="Brand" prop="rpcGoodsResVO.brandName" align="center" />
        <el-table-column label="Unit price" prop="taxUnitPrice" align="center">
          <template slot-scope="scope">AUD {{ scope.row.taxUnitPrice }}</template>
        </el-table-column>
        <el-table-column label="Quantity" prop="planQty" align="center" />
        <el-table-column label="Amount(AUD)" prop="totalPrice" align="center" />
      </el-table>
      <div class="flex-align flex-spacebetween" style="margin-top:50px">
        <div></div>
        <div>
          <div class="form-item flex-align" style="padding-top:10px;border-top:1px solid #000;">
            <div class="form-label">Carried Forward</div>
            <div class="form-value">{{ purchaseAmt }}</div>
          </div>
          <div class="form-item flex-align">
            <div class="form-label">Subtotal</div>
            <div class="form-value">AUD {{ purchaseAmt }}</div>
          </div>
          <div class="form-item flex-align">
            <div class="form-label">Total Tax</div>
            <div class="form-value">AUD {{ taxTotal || 0 }}</div>
          </div>
          <div class="form-item flex-align">
            <div class="form-label">Total</div>
            <div class="form-value">AUD {{ Number(purchaseAmt)+Number(taxTotal ||0) }}</div>
          </div>
        </div>
      </div>
      <div class="flex-align">
        <b>Signature______________________________</b>
        <b style="margin-left:5px;">Date______________________________</b>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import printJS from 'print-js';
export default {
    props: {
        data: {
            type: Object,
            default: null,
        }
    },
    computed: {
      purchaseAmt() {
        let total = 0;
        this.data.goodsList && this.data.goodsList.forEach(item => {
          total += item.totalPrice;
        });
        return total;
      },
      taxTotal() {
        return Number(this.purchaseAmt) * 0.1 + Number(this.data.totalFreight || 0);
      }
    },
    methods: {
        async exportPage() {
          const PDFView = this.$refs.pdfTemple;
          html2canvas(PDFView, {
            allowTaint: true,
            useCORS: true,
            dpi: 120, // 图片清晰度问题
            background: '#FFFFFF', // 如果指定的div没有设置背景色会默认成黑色,这里是个坑
          }).then(canvas => {
            // 未生成pdf的html页面高度
            var leftHeight = canvas.height;
            var a4Width = 841.89;
            var a4Height = 595.28; // A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
            // 一页pdf显示html页面生成的canvas高度;
            var a4HeightRef = Math.floor((canvas.width / a4Width) * a4Height);

            // pdf页面偏移
            var position = 0;
            var pageData = canvas.toDataURL('image/jpeg', 1.0);
            var pdf = new JsPDF('l', 'pt', 'a4'); // A4纸，纵向
            var index = 1; var canvas1 = document.createElement('canvas'); var height;
            pdf.setDisplayMode('fullwidth', 'continuous', 'FullScreen');

            function createImpl(canvas) {
              console.log(leftHeight, a4HeightRef);
              if (leftHeight > 0) {
                index++;
                var checkCount = 0;
                if (leftHeight > a4HeightRef) {
                  var i = position + a4HeightRef;
                  for (i = position + a4HeightRef; i >= position; i--) {
                    var isWrite = true;
                    for (var j = 0; j < canvas.width; j++) {
                      var c = canvas.getContext('2d').getImageData(j, i, 1, 1).data;
                      if (c[0] != 0xff || c[1] != 0xff || c[2] != 0xff) {
                        isWrite = false;
                        break;
                      }
                    }
                    if (isWrite) {
                      checkCount++;
                      if (checkCount >= 10) {
                        break;
                      }
                    } else {
                      checkCount = 0;
                    }
                  }
                  height = Math.round(i - position) || Math.min(leftHeight, a4HeightRef);
                  if (height <= 0) {
                    height = a4HeightRef;
                  }
                } else {
                  height = leftHeight;
                }
                canvas1.width = canvas.width;
                canvas1.height = height;
                console.log(index, 'height:', height, 'pos', position);
                var ctx = canvas1.getContext('2d');
                ctx.drawImage(canvas, 0, position, canvas.width, height, 0, 0, canvas.width, height);
                // var pageHeight = Math.round((a4Width / canvas.width) * height);
                // pdf.setPageSize(null, pageHeight)
                if (position != 0) {
                  pdf.addPage();
                }
                pdf.addImage(
                  canvas1.toDataURL('image/jpeg', 1.0), 'JPEG',
                  10, 10, a4Width, (a4Width / canvas1.width) * height
                );
                leftHeight -= height;
                position += height;
                if (leftHeight > 0) {
                  setTimeout(createImpl, 500, canvas);
                } else {
                  pdf.save('收货PDF模板.pdf');
                }
              }
            }

            // 当内容未超过pdf一页显示的范围，无需分页
            if (leftHeight < a4HeightRef) {
              pdf.addImage(pageData, 'JPEG', 0, 0, a4Width, (a4Width / canvas.width) * leftHeight);
              pdf.save('收货PDF模板.pdf');
            } else {
              try {
                pdf.deletePage(0);
                setTimeout(createImpl, 500, canvas);
              } catch (err) {
                console.log(err);
              }
            }
          });
        },
        async exportPage1() {
          const PDFView = this.$refs.pdfTemple1;
          html2canvas(PDFView, {
            allowTaint: true,
            useCORS: true,
            dpi: 120, // 图片清晰度问题
            background: '#FFFFFF', // 如果指定的div没有设置背景色会默认成黑色,这里是个坑
          }).then(canvas => {
            // 未生成pdf的html页面高度
            var leftHeight = canvas.height;
            var a4Width = 841.89;
            var a4Height = 595.28; // A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
            // 一页pdf显示html页面生成的canvas高度;
            var a4HeightRef = Math.floor((canvas.width / a4Width) * a4Height);

            // pdf页面偏移
            var position = 0;
            var pageData = canvas.toDataURL('image/jpeg', 1.0);
            var pdf = new JsPDF('l', 'pt', 'a4'); // A4纸，纵向
            var index = 1; var canvas1 = document.createElement('canvas'); var height;
            pdf.setDisplayMode('fullwidth', 'continuous', 'FullScreen');

            function createImpl(canvas) {
              console.log(leftHeight, a4HeightRef);
              if (leftHeight > 0) {
                index++;
                var checkCount = 0;
                if (leftHeight > a4HeightRef) {
                  var i = position + a4HeightRef;
                  for (i = position + a4HeightRef; i >= position; i--) {
                    var isWrite = true;
                    for (var j = 0; j < canvas.width; j++) {
                      var c = canvas.getContext('2d').getImageData(j, i, 1, 1).data;
                      if (c[0] != 0xff || c[1] != 0xff || c[2] != 0xff) {
                        isWrite = false;
                        break;
                      }
                    }
                    if (isWrite) {
                      checkCount++;
                      if (checkCount >= 10) {
                        break;
                      }
                    } else {
                      checkCount = 0;
                    }
                  }
                  height = Math.round(i - position) || Math.min(leftHeight, a4HeightRef);
                  if (height <= 0) {
                    height = a4HeightRef;
                  }
                } else {
                  height = leftHeight;
                }
                canvas1.width = canvas.width;
                canvas1.height = height;
                console.log(index, 'height:', height, 'pos', position);
                var ctx = canvas1.getContext('2d');
                ctx.drawImage(canvas, 0, position, canvas.width, height, 0, 0, canvas.width, height);
                // var pageHeight = Math.round((a4Width / canvas.width) * height);
                // pdf.setPageSize(null, pageHeight)
                if (position != 0) {
                  pdf.addPage();
                }
                pdf.addImage(
                  canvas1.toDataURL('image/jpeg', 1.0), 'JPEG',
                  10, 10, a4Width, (a4Width / canvas1.width) * height
                );
                leftHeight -= height;
                position += height;
                if (leftHeight > 0) {
                  setTimeout(createImpl, 500, canvas);
                } else {
                  pdf.save('澳洲本地产采购给客户的PDF模板.pdf');
                }
              }
            }

            // 当内容未超过pdf一页显示的范围，无需分页
            if (leftHeight < a4HeightRef) {
              pdf.addImage(pageData, 'JPEG', 0, 0, a4Width, (a4Width / canvas.width) * leftHeight);
              pdf.save('澳洲本地产采购给客户的PDF模板.pdf');
            } else {
              try {
                pdf.deletePage(0);
                setTimeout(createImpl, 500, canvas);
              } catch (err) {
                console.log(err);
              }
            }
          });
        },

        isSplit (nodes, index, pageHeight) {
            // 计算当前这块dom是否跨越了a4大小，以此分割
            return !!(nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight && nodes[index + 1] && nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight > pageHeight);
        },
        // 导出为pdf
        exportPDF() {
            // pdfTemple ref
            const PDFView = this.$refs.pdfTemple;
            // 获取分割dom，此处为class类名为item的dom
            const lableListID = document.getElementsByClassName('emptyItem');
            const pageHeight = PDFView.scrollWidth / 841.89 * 595.28; // (横版pdf)
            // 进行分割操作，当dom内容已超出a4的高度，则将该dom前插入一个空dom，把他挤下去，分割
            for (let i = 0; i < lableListID.length; i++) {
                const multiple = Math.ceil((lableListID[i].offsetTop + lableListID[i].offsetHeight) / pageHeight);
                if (this.isSplit(lableListID, i, multiple * pageHeight)) {
                    const divParent = lableListID[i].parentNode; // 获取该div的父节点
                    const newNode = document.createElement('div');
                    newNode.className = 'emptyDiv';
                    newNode.style.background = '#ffffff';
                    const _H = multiple * pageHeight - (lableListID[i].offsetTop + lableListID[i].offsetHeight);
                    console.log(pageHeight, lableListID[i].offsetTop, lableListID[i].offsetHeight);
                    newNode.style.height = _H + 'px';
                    newNode.style.width = '100%';
                    const next = lableListID[i].nextSibling; // 获取div的下一个兄弟节点
                    // 判断兄弟节点是否存在
                    if (next) {
                        // 存在则将新节点插入到div的下一个兄弟节点之前，即div之后
                        divParent.insertBefore(newNode, next);
                    } else {
                        // 不存在则直接添加到最后,appendChild默认添加到divParent的最后
                        divParent.appendChild(newNode);
                    }
                }
            }

            html2canvas(PDFView, {
                useCORS: true, // 是否尝试使用CORS从服务器加载图像
                allowTaint: true,
                dpi: 300, // 解决生产图片模糊
                scale: 3, // 清晰度--放大倍数
            }).then(
                (canvas) => {
                    const contentWidth = canvas.width;
                    const contentHeight = canvas.height;
                    // let pageHeight = contentWidth / 592.28 * 841.89 // 一页pdf显示html页面生成的canvas高度;
                    const pageHeight = contentWidth / 841.89 * 595.28; // 一页pdf显示html页面生成的canvas高度(横版pdf);
                    let leftHeight = contentHeight; // 未生成pdf的html页面高度
                    let position = 0; // pdf页面偏移

                    // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                    const imgWidth = 808; // 宽度（横版pdf）
                    const imgHeight = 841.89 / contentWidth * contentHeight; // （横版pdf）
                    const pageData = canvas.toDataURL('image/jpeg', 1.0);
                    const PDF = new JsPDF('l', 'pt', 'a4');
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, 'JPEG', 20, 20, imgWidth, imgHeight);
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, 'JPEG', 20, position, imgWidth, imgHeight);
                            leftHeight -= pageHeight;
                            position -= 595.28; // (横版pdf)
                            // position -= 841.89
                            if (leftHeight > 0) {
                                PDF.addPage();
                            }
                        }
                    }
                    PDF.save('b.pdf'); // 下载标题
                    // // 将前面处理内容分割问题在页面中加上的空白占位结点去掉
                    const emptyDiv = document.getElementsByClassName('emptyDiv');
                    for (let i = 0; i < emptyDiv.length; i++) {
                        emptyDiv[i].remove();
                        i = i - 1;
                    }
            });
        },
        goPrint() {
            html2canvas(this.$refs.pdfTemple, {
                allowTaint: true,
                taintTest: false,
                useCORS: true,
                dpi: window.devicePixelRatio * 4,
                scale: 4,
                logging: true, // 日志开关，便于查看html2canvas的内部执行流程
            }).then((canvas) => {
                const url = canvas.toDataURL();
                printJS({
                    printable: url, // 要打印的id
                    type: 'image',
                    style: '@page{size:auto;margin: 0cm 1cm 0cm 1cm;}' // 去除页眉页脚
                });
            });
        },
    }
};
</script>
<style lang="scss" scoped>
.pdfTemple {
  font-size: 12px;
  padding: 20px;
  .title {
    font-size: 18px;
    color: #8f8f8f;
    font-weight: bold;
  }
  .form-item {
    margin-bottom: 5px;
  }
  .form-label {
    font-weight: bold;
    width: 200px;
  }
}
::v-deep .emptyItem th.el-table__cell > .cell {
  padding: 0;
}
</style>
